import Button from "../buttons/button/Button";
import React, { useCallback, useEffect, useRef, useState } from "react";
// import {FC} from "react";
import "./Faq.scss";
import Accordion from "../accordion/Accordion";
import useFetch, { CachePolicies } from "use-http";
import classNames from "classnames";
import Heading from "../typography/heading/Heading";
import queryString from 'query-string';
import Alert from "../alert/Alert";

type category = {
  id: number;
  title: string;
  slug: string;
};

type item = {
  slug: string;
  title: string;
  content: string;
  categories: category[];
};

interface categoriesResponse {
  categories:category[];
  labels: labels;
}

interface labels {
  categories_title: string;
  search: Search;
  feedback: Feedback;
}

export interface Feedback {
  title: string;
  response: string;
  yes_btn: string;
  no_btn: string;
}

interface Search {
  title: string;
  placeholder: string;
  search_results: string;
  no_results: string;
  minimum_characters: string;
  results: string;
  no_results_subtitle: string;
  minimum_characters_subtitle: string;
}

const Faq = () => {
  const [items, setItems] = useState<item[]>();
  const [categories, setCategories] = useState<category[]>();
  const [categoryName, setCategoryName] = useState<string>("");
  const [activeCategory, setActiveCategory] = useState<string | undefined>(undefined);
  const [search, setSearch] = useState<string>("");
  const [activeItem, setActiveItem] = useState<string | undefined>(undefined)
  const [labels, setLabels] = useState<labels>()
  const { get, post, response, loading, error } = useFetch(`/${document.documentElement.lang}/api/faq`);
  const ref = useRef(null);

  const getCategories = useCallback(async () => {
    const categoriesResponse:categoriesResponse = await get("categories.json");
    if (response.ok) {
      setCategories(categoriesResponse.categories);
      handleCategory(categoriesResponse.categories)
      setLabels(categoriesResponse.labels)
    }
  }, [get, setCategories]);

  useEffect(() => {
    getCategories();
  }, [getCategories]);


  const handleActiveItem = useCallback(async (slug: string) => {
    slug && await post(`items/${slug}/count`);
    setActiveItem(slug)
    
  }, [post, setActiveItem, activeItem])

  const getFaqItems = useCallback(
    async (slug: string) => {
      const allItems = await get(`categories/${slug}.json`);
      if (response.ok) setItems(allItems);
    },
    [get]
  );

  const handleCategory = useCallback((allCategories: category[]) => {
    let firstCategory;    
    const query = new URLSearchParams(window.location.search);
    const urlCat = query.get('cat')
    const urlItem = query.get('item')
    
    if (urlItem) setActiveItem(urlItem)

    const urlCategory = allCategories.find((category: category) => {
      if(category.slug === urlCat) {
        return category
      }
    })
    
    firstCategory = urlCategory ? urlCategory : allCategories[0];
    setActiveCategory(firstCategory.slug);
    setCategoryName(firstCategory.title);
    getFaqItems(firstCategory.slug);
  },[setActiveCategory, setCategoryName, getFaqItems])

  const scrollToTop = () => {
    ref.current?.scrollIntoView({behavior: 'smooth'});
  }

  const handleCategoryClick = useCallback((slug: string, title: string) => {
    setCategoryName(title);
    setActiveCategory(slug);
    getFaqItems(slug);
    setSearch("");
    setActiveItem(undefined);
    scrollToTop()
  },[setCategoryName, setActiveCategory, getFaqItems, setSearch, scrollToTop]);

  useEffect(() => {
    if(activeCategory || activeItem) {
      const urlQuery = queryString.stringify({cat: activeCategory, item: activeItem}, {
        skipNull: true
      });
      const newUri = window.location.protocol + "//" + window.location.host + window.location.pathname + `?${urlQuery}`;    
      window.history.pushState({ newUri }, '', newUri);
    }
  }, [activeCategory, activeItem])

  const handleSearch = useCallback(async (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value);
    if (event.target.value.length >= 3) {
      const searchResults = await get(`search.json?q=${event.target.value}`);
      if (response.ok) {
        setItems(searchResults.results);
      }
    } else {
      setItems(undefined);
    }
    setActiveCategory(undefined);
    setCategoryName("");
  }, []);

  return (
    <div className="react-faq" ref={ref}>
      <div className="react-faq__categories">
        <span className="react-faq__label">{labels?.categories_title}</span>
        <ul className="react-faq__categories-items">
          {categories?.map((category) => {
            return (
              <li key={category.slug}>
                <button onClick={() => handleCategoryClick(category.slug, category.title)} className={classNames("react-faq__categories-item", { "is-active": activeCategory === category.slug })}>
                  {category.title}
                </button>
              </li>
            );
          })}
        </ul>
      </div>
      <div className="react-faq__search-wrapper">
        <div className="react-faq__search">
          <span className="react-faq__label">{labels?.search?.title}</span>
          <input className="form__input form__input--big" placeholder={labels?.search?.placeholder} type="text" value={search} onChange={(e) => handleSearch(e)} />
        </div>
        <Heading level={3} stylingLevel={2} className="react-heading--mb  react-heading--grey">
          {search.length ? `${labels?.search.results} '${search}'` : categoryName}
        </Heading>
        
        {(items && items?.length > 0) && <Accordion items={items} activeItem={activeItem} handleActiveItem={handleActiveItem} labels={labels.feedback} />}
        {(items?.length === 0 && search.length >= 3) && <Alert type='blue' label={labels?.search.no_results} subtitle={labels?.search.no_results_subtitle} />}
        {search.length > 0 && search.length < 3 && <Alert type='blue' label={labels?.search.minimum_characters} subtitle={labels?.search.minimum_characters_subtitle} />}
      </div>
    </div>
  );
};

export default Faq;
